// extracted by mini-css-extract-plugin
module.exports = {"contactSection":"ContactSection_contactSection__3DfWx","txt":"ContactSection_txt__19Lqw","center":"ContactSection_center__3LITW","btnSize":"ContactSection_btnSize__299F9"};